import {usePlayers} from '@glark-newco/game-library';
import {DisplayPlaySceneButton} from './DisplayPlaySceneButton';
import {ReviewStatsPanel} from './ReviewStatsPanel';

export function ReviewOverlay() {
    const {localPlayer} = usePlayers();

    return (
        <>
            {localPlayer.isFacilitator &&
                <DisplayPlaySceneButton/>
            }
            <ReviewStatsPanel/>
        </>
    );
}
